import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {all, fork, put, takeEvery} from "redux-saga/effects";
import ContentService from '../../services/content.service';

function* getContentList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const search = action.payload?.search;
      const status = action.payload?.statusType;
      const service_id = action.payload?.service_id;
      let params = {page, pageSize, service_id, search, status};
      // let params = action.payload;

      const response = yield ContentService.list(params);

      if (response?.data.statusCode === 200) {
        yield put(actions.getContentListSuccess(response?.data?.data));
      } else {
        yield put(actions.getContentListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getContentListFailure(error));
  }
}

function* getContentListSaga() {
  yield takeEvery(actionsTypes.GET_CONTENT_LIST_START, getContentList);
}

function* uploadContentsList(action) {
  try {
    if (action.payload) {
      const response = yield ContentService.createContentsList(action.payload);
      // console.log({response})
      if (response?.data.statusCode) {
        yield put(actions.addContentSuccess(response?.data));
      } else {
        yield put(actions.addContentFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addContentFailure(error));
  }
}

function* uploadContentsListSaga() {
  yield takeEvery(actionsTypes.UPLOAD_CONTENTS_LIST_START, uploadContentsList);
}

function* addContent(action) {
  try {
     if (action.payload) {
      const response = yield ContentService.create(action.payload);
   
    // if (action.payload) {
    //   const response = yield CPManagersService.createCP(action.payload);
      if (response?.data.statusCode == 201) {
        yield put(actions.addContentSuccess(response.data));
      } else if (response?.data.statusCode == 400){
        yield put(actions.addContentFailure(response.data))
      } else {
        yield put(actions.addContentFailure("no user data"));
      }
    // }
  }
  } catch (err) {
    let error = err?.response?.data?.message;
    console.log(error)

    if (!error) {
      error = "network error"
    }
    yield put(actions.addContentFailure(error));
  }
}

function* contentEdit(action) {
  try {
    if (action.payload) {
         let payload = action.payload
         delete payload.create;
        let data = payload;
        let id = data.id;
        delete data.id
        if (data.newCpId) {
          data = {...data, id: data.newCpId}
          delete data.newCpId
        }
       const response = yield ContentService.update(id, data);
       if (response?.data.statusCode) {
        yield put(actions.addContentSuccess(response.data));
      } else {
        yield put(actions.addContractFailure("no user data"));
      }
 }
  } catch (err) {
    let error = err?.response?.data?.message;
    console.log(error)

    if (!error) {
      error = "network error"
    }
    yield put(actions.addContentFailure(error));
  }
}

function* contentEditSaga() {
  yield takeEvery(actionsTypes.Edit_CONTENT, contentEdit);
}

// function* addContent(action) {
//   try {
//     const payload = action.payload
//     let response = ''
//     if (payload.create) {
//       delete payload.create
//       response = yield ContentService.create(payload);
//     } else {
//       delete payload.create
//       response = yield ContentService.update(payload.id, payload);
//     }
//     if (response?.data.statusCode) {
//       yield put(actions.addContentSuccess(response?.data));
//     } else {
//       yield put(actions.addContentFailure("no data"));
//     }
//   } catch (err) {
//     let error = err?.response?.data?.message;

//     if (!error) {
//       error = "network error"
//     }
//     yield put(actions.addContentFailure(error));
//   }
// }

function* addContentSaga() {
  yield takeEvery(actionsTypes.ADD_CONTENT_START, addContent);
}

export function* contentSaga() {
  yield all([
    fork(getContentListSaga), fork(addContentSaga), fork(uploadContentsListSaga), fork(contentEditSaga)
  ]);
}
